import { isDesktop, isMobile, isTablet } from 'react-device-detect';

export const getDeviceType = (): Promise<string> => {
  return Promise.resolve(
    isMobile ? 'mobile' : isTablet ? 'tablet' : isDesktop ? 'desktop' : 'unknown',
  );
};
